<p-card
	[header]="
		'presentation.app.page.settings.coach.general.sectors.header' | translate
	"
	class="h-full"
	styleClass="h-full"
>
	<div [formGroup]="sectorsForm">
		<p-listbox
			[checkbox]="true"
			[listStyle]="{ 'max-height': '160px' }"
			[multiple]="true"
			[options]="sectorOptions$ | async"
			[showToggleAll]="false"
			[style]="{ width: '100%', height: '100%' }"
			formControlName="sectors"
		></p-listbox>
	</div>
</p-card>
